
import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { RouterModule } from '@angular/router';
import { of } from 'rxjs';
import { switchMap, takeUntil } from 'rxjs/operators';
import { ExternalNavMenuComponent } from './external-nav-menu/external-nav-menu.component';
import { InternalNavMenuComponent } from './internal-nav-menu/internal-nav-menu.component';
import { toSignal } from '@angular/core/rxjs-interop';
import { ObservableBaseComponent } from '@scl/shared/components/observable-base.component';
import { AccountService } from '@scl/core/services/account.service';

@Component({
  selector: 'app-nav-menu',
  imports: [
    RouterModule,
    ExternalNavMenuComponent,
    InternalNavMenuComponent
],
  templateUrl: './nav-menu.component.html',
  styleUrls: ['./nav-menu.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NavMenuComponent extends ObservableBaseComponent {

  private accountService = inject(AccountService);
  isInternal = signal(false);

  showMenu = toSignal(this.accountService.currentUser$
    .pipe(
      takeUntil(this.unsubscribe$),
      switchMap(usr => {
        if (!usr) {
          return of(false);
        };
        this.isInternal.set(usr.roles!.some(r => !r.isExternal));
        return of(true);
      })
    ));
}
